<div class="page-header">
  <div>
    <h1 class="title">
      <i class="pi pi-clock"></i>
      {{ 'SESSIONS.MY_SESSIONS' | translate }}
    </h1>
    <p class="sub">الأجهزة والجلسات النشطة على حسابك</p>
  </div>
  <div class="tools">
    <button
      pButton
      icon="pi pi-ban"
      [label]="'COMMON.REVOKE_ALL' | translate"
      class="p-button-danger p-button-outlined"
      (click)="revokeAll()"
    ></button>
  </div>
</div>

<p-table
  [value]="groups"
  dataKey="device"
  [expandedRowKeys]="expandedRowKeys"
  styleClass="sessions-table"
  [tableStyle]="{ 'min-width': '60rem' }"
>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 3rem"></th>
      <th>الجهاز</th>
      <th>{{ 'SESSIONS.IP' | translate }}</th>
      <th>آخر نشاط</th>
      <th>{{ 'SESSIONS.EXPIRES' | translate }}</th>
      <th class="text-center" style="width: 7rem">الجلسات</th>
      <th class="text-center" style="width: 8rem">{{ 'COMMON.STATUS' | translate }}</th>
      <th class="text-end" style="width: 12rem">{{ 'COMMON.ACTIONS' | translate }}</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-g let-expanded="expanded">
    <tr class="group-row" [class.is-expanded]="expanded">
      <td>
        <button
          pButton
          type="button"
          [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-left'"
          class="p-button-text p-button-sm chev-btn"
          (click)="toggleRow(g)"
        ></button>
      </td>
      <td>
        <div class="device-cell">
          <span class="device-icon"><i [class]="deviceIcon(g.device)"></i></span>
          <span class="device-name" [title]="g.device">{{ g.device }}</span>
        </div>
      </td>
      <td>
        <code class="ip-code" *ngIf="g.ipAddress; else dash">{{ g.ipAddress }}</code>
        <ng-template #dash>—</ng-template>
      </td>
      <td>{{ g.latestCreatedAt | date: 'medium' }}</td>
      <td>{{ g.latestExpiresAt ? (g.latestExpiresAt | date: 'medium') : '—' }}</td>
      <td class="text-center">
        <span class="count-badge">{{ g.sessions.length }}</span>
      </td>
      <td class="text-center">
        <span
          class="chip"
          [class.chip--success]="g.anyActive"
          [class.chip--danger]="!g.anyActive"
        >
          <i class="pi" [class.pi-check-circle]="g.anyActive" [class.pi-times-circle]="!g.anyActive"></i>
          {{ g.anyActive ? ('COMMON.ACTIVE' | translate) : ('COMMON.INACTIVE' | translate) }}
        </span>
      </td>
      <td class="text-end">
        <button
          pButton
          icon="pi pi-power-off"
          label="إنهاء الكل"
          class="p-button-danger p-button-sm p-button-outlined"
          [disabled]="!g.anyActive"
          (click)="revokeGroup(g); $event.stopPropagation()"
        ></button>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="rowexpansion" let-g>
    <tr class="expansion-row">
      <td colspan="8">
        <div class="expansion-wrap">
          <div class="expansion-title">
            <i class="pi pi-list"></i>
            <span>جلسات هذا الجهاز ({{ g.sessions.length }})</span>
          </div>
          <table class="inner-table">
            <thead>
              <tr>
                <th>{{ 'SESSIONS.SESSION_ID' | translate }}</th>
                <th>{{ 'SESSIONS.IP' | translate }}</th>
                <th>{{ 'SESSIONS.CREATED' | translate }}</th>
                <th>{{ 'SESSIONS.EXPIRES' | translate }}</th>
                <th class="text-center">{{ 'COMMON.STATUS' | translate }}</th>
                <th class="text-end">{{ 'COMMON.ACTIONS' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let s of g.sessions">
                <td>
                  <code class="session-id" [pTooltip]="s.id">{{ s.id | slice: 0:8 }}…</code>
                </td>
                <td>
                  <code class="ip-code" *ngIf="s.ipAddress; else dashInner">{{ s.ipAddress }}</code>
                  <ng-template #dashInner>—</ng-template>
                </td>
                <td>{{ s.createdAt | date: 'medium' }}</td>
                <td>{{ s.expiresAt ? (s.expiresAt | date: 'medium') : '—' }}</td>
                <td class="text-center">
                  <span
                    class="chip"
                    [class.chip--success]="s.isActive"
                    [class.chip--danger]="!s.isActive"
                  >
                    <i class="pi" [class.pi-check-circle]="s.isActive" [class.pi-times-circle]="!s.isActive"></i>
                    {{ s.isActive ? ('COMMON.ACTIVE' | translate) : ('COMMON.INACTIVE' | translate) }}
                  </span>
                </td>
                <td class="text-end">
                  <button
                    pButton
                    icon="pi pi-times"
                    [label]="'COMMON.REVOKE' | translate"
                    class="p-button-danger p-button-sm p-button-text"
                    [disabled]="!s.isActive"
                    (click)="revoke(s)"
                  ></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="8" class="empty-state">
        <div class="empty-content">
          <i class="pi pi-inbox"></i>
          <p>لا توجد جلسات</p>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
